import React from 'react';
import PropTypes from 'prop-types';

/**
 * Adds automatic activeState management to tabs
 */
export default function withState([WrappedTabsList, WrappedTabsItem]) {
  class StatefulTabsList extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        /** if value is missing, empty string is used by default */
        activeId: 'activeId' in props ? props.activeId : '',
      };
    }

    handleChange = (activeId) => {
      const { onChange } = this.props;
      this.setState({ activeId });
      if (onChange) onChange(activeId);
    };

    render() {
      const { activeId } = this.state;

      return <WrappedTabsList {...this.props} onChange={this.handleChange} activeId={activeId} />;
    }
  }

  StatefulTabsList.propTypes = {
    type: PropTypes.string,
    overflow: PropTypes.string,
    activeId: PropTypes.any,
    onChange: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    // TODO: add more prop types
  };

  /**
   * Override component name by enclosing in `Stateful~`
   * to make it look nice, for example: `StatefulTabsList`
   */
  if (process.env.NODE_ENV !== 'production') {
    const WrappedComponentName = WrappedTabsList.displayName || WrappedTabsList.name || 'TabsList';
    StatefulTabsList.displayName = `Stateful${WrappedComponentName}`;
  }

  return [StatefulTabsList, WrappedTabsItem];
}
